// extracted by mini-css-extract-plugin
export var content = "_oa-1";
export var fullScreen = "_oa-0";